import React from "react";
import Flagship from "../../core/flagship";
import { Dropdown, Icon, Label } from "semantic-ui-react";
import { throttle, empty } from "../../utils/helpers";

class UserField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onReset = this.onReset.bind(this);
    this.setInputRef = this.setInputRef.bind(this);
    this.focusUserInput = this.focusUserInput.bind(this);

    this.userInput = null;
    this.preventFocus = this.props.preventFocus;
    this.getUserFromId = this.getUserFromId.bind(this);
    this.focusUserInput = this.focusUserInput.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  getInitialState() {
    return {
      searchResults: [],
      emptySearch: false,
      userData:
        typeof this.props.userData === "object" ? this.props.userData : {},
      focused: !this.props.preventFocus,
      expanded: !empty(this.props.expanded) ? this.props.expanded : true,
    };
  }

  componentDidMount() {
    if (this.preventFocus !== true) {
      this.focusUserInput();
    }

    if (this.props.userData !== "object" && !empty(this.props.userData)) {
      this.getUserFromId(this.props.userData);
    }
  }

  getUserFromId(id) {
    let self = this;
    Flagship.get(
      "user/" + id,
      {},
      function (response) {
        if (response.data.success === true) {
          let userData = response.data.user;

          if (!empty(userData)) {
            userData.text = userData.first_name + " " + userData.last_name;
          }

          self.setState({
            userData,
          });
        }
      },
      function (err) {
        Flagship.error(
          "Error getting user data: " + err,
          id,
          self.props.userId
        );
      }
    );
  }

  focusUserInput() {
    if (this.userInput) {
      this.userInput.focus();
    }
  }

  setInputRef(element) {
    this.userInput = element;
  }

  searchUsers(like) {
    let self = this;

    let params = {
      search: like,
    };

    if (empty(this.props.limitInstance)) {
      params["instance"] = this.props.limitInstance;
    }

    Flagship.get(
      "dropdown-search/user",
      params,
      function (response) {
        if (response.data.success === true) {
          self.setState({
            searchResults: response.data.results,
            emptySearch:
              empty(response.data.results) ||
              response.data.results.length === 0,
          });
        } else {
          Flagship.error(
            "Could not retrieve dropdown search results for user field. Query: " +
              like,
            0,
            0
          );
        }
      },
      function (err) {
        Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
      }
    );
  }

  onChange(e, data) {
    let newData = Object.assign({}, this.state.userData);
    newData.id = data.value;
    let newFullName = "";

    data.options.map(function (item) {
      if (item.value === data.value) {
        newFullName = item.text;
      }
    });

    newData.text = newFullName;

    this.setState(
      {
        userData: newData,
      },
      function () {
        if (typeof this.props.onChange === "function") {
          this.props.onChange(e, data);
        }
      }
    );
  }

  onSearchChange(e, data) {
    this.props.onChange(null, { value: false });

    let search = this.searchUsers.bind(this);
    this.timer = throttle(
      function () {
        search(data);
      },
      400,
      this.timer
    );
  }

  onReset() {
    let self = this;
    this.preventFocus = false;
    this.setState(
      {
        userData: null,
        focused: true,
      },
      function () {
        self.focusUserInput();
        if (typeof self.props.onReset === "function") {
          self.props.onReset();
        }
      }
    );
  }

  handleFocus() {
    this.setState({
      focused: true,
    });
  }

  handleBlur() {
    this.setState({
      focused: false,
    });
  }

  toggleExpanded() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    return (
      <div>
        {this.props.label ? (
          <Label className="single-field-label user-field-label" size="large">
            {this.props.label}
            {this.props.required === "1" ||
            this.props.required === true ||
            this.props.required === 1 ? (
              <Icon
                color="red"
                size="tiny"
                className="asterisk"
                name="asterisk"
              />
            ) : null}
          </Label>
        ) : null}

        <Dropdown
          className="user-search"
          fluid
          search
          openOnFocus
          searchInput={{ autoFocus: !this.preventFocus }}
          placeholder="Search by name..."
          selection
          text={this.state.userData !== null ? this.state.userData.text : null}
          noResultsMessage="No users found by this name."
          label={this.props.label}
          onChange={this.onChange}
          onSearchChange={this.onSearchChange.bind(this)}
          options={this.state.searchResults}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          value={this.state.userData !== null ? this.state.userData.id : null}
        />
        {this.props.allowDelete && this.state.userData !== null ? (
          <Icon
            circular
            style={{
              cursor: "pointer",
              marginTop: ".25em",
              marginLeft: ".25em",
            }}
            className="user-field-delete"
            name="delete"
            color="red"
            onClick={this.onReset}
          />
        ) : null}
        {this.state.emptySearch === true ? (
          <div>
            <br />
            No matching users found.
          </div>
        ) : this.state.focused === true ? (
          <div>
            <br />
            <br />
          </div>
        ) : null}
      </div>
    );
  }
}

export default UserField;



// WEBPACK FOOTER //
// ./src/components/misc/UserField.js